import './css/Produto.css';

function Produto(props) {
  return (
    <div className='produto-card'>
      <div className='thumbnail' style={{
        backgroundImage: 'url(' + props.url_api + '/' + props.produto.imagem + ')'
      }}></div>
        <div className='produto-body'>
          <span className='produto-nome'>{props.produto.nome}</span>
          <span className='marca'>{props.produto.marca}</span>
          <div className='columns'>
            <span>{props.produto.km} KM</span>
            <span>{props.produto.ano_fabricacao} / {props.produto.ano_modelo}</span>
          </div>
          
        </div>
        <div className='produto-footer'>
          <span className='valor'>{props.produto.valor.toLocaleString('en-US', {style: 'currency', currency: 'BRL',})}</span>
          <a target='_blank' href={"https://autotruckrecuperadora.com.br/lojadetalhe.html?id=" + props.produto.id} className='btn-comprar'>SAIBA MAIS</a>
        </div>
    </div>
  );
}

export default Produto;
